<script>
    export default {
        name: "OrangopackCard",

        props: {
            item: Object
        },
        data() {
            return {
                activePromotions: [],
                minPromotion: null,
                imageBackground: null,
                date: moment().add(48, 'hours'),
                now: Math.trunc(moment().valueOf() / 1000),
            }
        },
        computed: {
            ageRange(){
                return this.item.start_age + " - " + this.item.end_age + " anni";
            },
            dateInMilliseconds() {
                return Math.trunc(this.date.valueOf() / 1000)
            },
            seconds() {
                let seconds = (this.dateInMilliseconds - this.now) % 60;
                return seconds <= 9 ? `0${seconds}` : seconds;
            },
            minutes() {
                let minutes = Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
                return minutes <= 9 ? `0${minutes}` : minutes
            },
            hours() {
                let hours = Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
                return hours <= 9 ? `0${hours}` : hours
            },
            totalPrice() {
                if (! this.minPromotion) {
                    return '0.00'
                }

                let total = parseFloat(this.minPromotion.price);
                if(this.item.active_promotion_fee){
                    total += parseFloat(this.item.promo_membership_fee * this.minPromotion.people);
                }
                return total.toFixed(2)
            },
            getPromotionText() {
                if (this.minPromotion) {
                    let lessons = this.minPromotion.lessons > 1 ? 'lezioni' : 'lezione'
                    let people = this.minPromotion.people > 1 ? 'persone' : 'persona'
                    let lessonType = this.minPromotion.lesson_type == 'group' ? 'di gruppo' : 'individuale'

                    return `${this.minPromotion.lessons} ${lessons} di <span class='text-primary text-uppercase'>${this.item.sport.name} </span> per ${this.minPromotion.people} ${people}`
                }
                return null
            },  
        },
        mounted() {
            let courseDate = moment(this.item.updated_at).add(48, 'hours');
            let now = moment();
            while((courseDate.isBefore(now))) {
                courseDate = courseDate.add(48, 'hours');
            }
            this.$set(this, 'date', moment(courseDate));

            let vm = this;
            window.setInterval(() => {
                vm.now = Math.trunc(moment().valueOf() / 1000);
            }, 1000);

            this.getActivePromotions()
            this.getImageBackground()
            this.getMinPromotion();
        },
        methods: {          
            getActivePromotions() {
                if (!_.isArray(this.item.promotions)) {
                    return
                }

                let active = this.item.promotions.filter(i => i.is_active)

                if (active.length > 0) {
                    this.activePromotions = active.sort(function (a,b) {
                        return a.price - b.price;
                    })
                }
            },
            getMinPromotion() {
                this.$set(this, 'minPromotion', _.min(this.activePromotions, i => i.price))
            },      
            getImageBackground() {
                if (!_.isEmpty(this.item.course_thumb_image)) {
                    this.$set(this, 'imageBackground', {
                        'background-image': `url(${this.item.course_thumb_image_full})`
                    })
                }
                this.$set(this, 'imageBackground', {
                    'background-image': `url("${this.item.course_image}")`
                })
            },
            onShowInvitation(course, target = '_self') {
                window.open(route('courses.promotion.show', this.item.slug), target)
            },
            formattedAddress(course){
                var string = "";
                course.municipality ? string += course.municipality : string += "";
                course.route ? (string += ", " + course.route ): string += "";
                course.house_number ? (string += " " + course.house_number ): string += "";
                return string;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/OrangopackCard.vue